/* eslint-disable */
$(document).ready(function () {
  if($('.win-full-page').length > 0) {
    loadDropdown();
    loadCheckboxes();
    animateTerms();
    GetHeight();
    $(window).resize(function () {
        GetHeight();
    });
    // reload on partial postback
    var prm = Sys.WebForms.PageRequestManager.getInstance();
    if (prm != null) {
        prm.add_endRequest(function (sender, e) {
            if (sender._postBackSettings.panelsToUpdate != null) {
                loadDropdown();
                loadCheckboxes();
                animateTerms();
                GetHeight();
                $(window).resize(function () {
                    GetHeight();
                });
                RedirectUser();
            }
        });
    };
  }
});



// Get required page height
function GetHeight() {
    if($('.win-terms-text.open-terms').length) {
      $('form').css('height', '100%');
      $('.win-terms-text.open-terms').css('height', '100%');
      var height = 0;
      var termsHeight = $('.terms-btn-text').offset().top + 50;
      var selectHeight = 0;

      if ($('.cs-options').length > 0) {
          var dropHeight = $('.cs-options').height();
          if (dropHeight < 199) {
              dropHeight = 199;
          }
          selectHeight = $('.cs-options').offset().top + dropHeight + 40;
      }

      if (termsHeight > selectHeight) {
          height = termsHeight;
      } else {
          height = selectHeight;
      }

      if (height > $(window).outerHeight()) {
          $('form').css('height', height);
          $('.win-terms-text').attr('data-height', height);
      }
      else {
          $('.win-terms-text').attr('data-height', '100%');
      }
    }
}

// Initialise select
function loadDropdown() {
    [].slice.call(document.querySelectorAll('select.cs-select')).forEach(function (el) {
        new SelectFx(el);
    });

    $('input, textarea').placeholder();
}

//Checkboxes
function loadCheckboxes() {
    var $checkboxes = $('input[type=checkbox]');
    $checkboxes.each(function () {
        var $cb = $(this);
        var $label = $('label[for=' + $cb.attr('id') + ']');

        if ($label.length && $label.children('span').length === 0) {
            $label
                .wrapInner('<p></p>')
                .prepend('<span></span>')
                .addClass('checkLbl');

            $cb.change(function () {
                $label.toggleClass('checked');
            });

            if ($cb.is(':checked')) {
                $label.addClass('checked');
            }
        }
    });
}

function animateTerms() {
    //Open Terms animation
    $('.view-terms-conditions-agree.primary').click(function () {
        var $termsText = $('.win-terms-text.primary');

        if (!$termsText.hasClass('open-terms')) {
            $termsText.addClass('open-terms');
            $termsText.height($termsText.attr('data-height'));
        }
        else {
            $termsText.removeClass('open-terms');
        }
    });
    //Open Terms animation
    $('.view-terms-conditions-agree.secondary').click(function () {
        var $termsText = $('.win-terms-text.secondary');

        if (!$termsText.hasClass('open-terms')) {
            $termsText.addClass('open-terms');
            $termsText.height($termsText.attr('data-height'));
        }
        else {
            $termsText.removeClass('open-terms');
        }
    });

    //Close on X
    $('.win-terms-text .close-terms').click(function () {
        var $termsText = $('.win-terms-text');

        if (!$termsText.hasClass('open-terms')) {
            $termsText.addClass('open-terms');
        }
        else {
            $termsText.removeClass('open-terms');
            $termsText.height(0);
        }
    });

    //Close terms on esc
    $(document).keyup(function (e) {

        if (e.keyCode == 27) {
            var $termsText = $('.win-terms-text');

            if ($termsText.hasClass('open-terms')) {
                $termsText.removeClass('open-terms');
                $termsText.height(0);
            }
        }
    });
}

function RedirectUser(url) {
    var $redir = $('.redirect-url');
    if ($redir.length > 0) {
        var timeout = parseInt($redir.attr('data-timeout')) || 5000;
        setTimeout(function () {
            window.location.href = $redir.text();
        }, timeout);
    }
}
/* eslint-enable */
